export default __webpack_public_path__ + "static/media/art-4-carrots-lg.330c3ea1.jpg";